<div class="fullcontainer pr-3">
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Sage Tax Codes</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/invoices/sage-export'>
        <i class="fas fa-file-export"></i> Build a Batch
      </button>
    </div>
  </div>
  <br />

  @if (this.isError) {
    <div class='alert alert-danger'>Could not load the tax types. Please try again later.</div>
  }

  <div class='sheet'>
    <p>
      Each tax type needs the code Sage knows it by. A tax type with no code
      <strong>stops the whole export</strong> rather than being guessed at, and that is
      deliberate: the rate cannot supply the code. 0% is <strong>T0</strong> zero-rated,
      <strong>T2</strong> exempt or <strong>T9</strong> outside the scope of VAT, and those are
      different boxes on a VAT return. Everything here is seeded <strong>T1</strong> per your
      instruction &mdash; check each one against your Sage before relying on it.
    </p>

    @if (this.unmappedCount > 0) {
      <div class='alert alert-warning mb-0'>
        <strong>{{ this.unmappedCount }} tax type(s) have no Sage code.</strong>
        Any invoice using one of them will refuse the next batch until it is set.
      </div>
    }
  </div>

  <div class='sheet'>
    @if (this.loading) {
      <p class='m-0'><i class="fas fa-spinner fa-spin"></i> Loading&hellip;</p>
    } @else {
      <table class='table'>
        <thead>
          <th>Name</th>
          <th>Rate</th>
          <th>Sage Code</th>
          <th></th>
          <th></th>
        </thead>
        <tbody>
          @for (taxCode of this.taxCodes; track taxCode.id) {
            <tr [class.table-warning]='this.isUnmapped(taxCode)'>
              <td>{{ taxCode.name }}</td>
              <td>{{ this.formatRate(taxCode.rate) }}</td>
              <td>
                <input type='text' class='form-control' maxlength='8'
                  [(ngModel)]='taxCode.sageCode'
                  [name]='"sageCode" + taxCode.id'
                  placeholder='e.g. T1'>
              </td>
              <td>
                <button class='btn btn-primary' (click)='this.save(taxCode)'
                  [disabled]='this.saving[taxCode.id]'>
                  @if (this.saving[taxCode.id]) {
                    <i class="fas fa-spinner fa-spin"></i>
                  } @else {
                    Save
                  }
                </button>
              </td>
              <td>
                @if (this.saved[taxCode.id]) {
                  <span class='text-success'>Saved.</span>
                }
                @if (this.errors[taxCode.id]) {
                  <span class='text-danger'>{{ this.errors[taxCode.id] }}</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (this.taxCodes.length === 0) {
        <p class='m-0 text-muted'>No tax types are set up.</p>
      }
    }
  </div>
</div>
